import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, ModalDismissReasons, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Subscription, timer } from 'rxjs';
import { GlobalsService } from '@services/globals.service';
import { PaymentDeviceService } from "@services/devices";

/**
  Componente para mostrar un modal de espera con temporizador.
  Este componente muestra un modal que cuenta regresivamente desde 60 segundos.
  Si el temporizador llega a cero, se redirige al usuario a la página de inicio y se limpian los datos globales.
  También permite al usuario confirmar o cancelar la acción manualmente.
**/
@Component({
    selector: 'app-wait-modal',
    templateUrl: './wait-modal.component.html',
    styleUrls: ['./wait-modal.component.scss'],
    standalone: false
})
export class WaitModalComponent implements OnInit, OnDestroy{

 /**
    Temporizador que cuenta regresivamente desde 60 segundos.
  **/
    timer = 60;

    /**
      Fuente del temporizador que emite un valor cada segundo.
    **/
    source = timer(1000, 1000);

    /**
      Suscripción al temporizador para gestionar su ciclo de vida.
    **/
    suscribeMember: Subscription;

    /**
      Opciones de configuración del modal.
      - backdrop: 'static' evita que el modal se cierre al hacer clic fuera de él.
      - keyboard: false deshabilita el cierre del modal al presionar la tecla ESC.
    **/
    ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };

    /**
      Almacena el resultado del cierre del modal.
    **/
    closeResult = '';
  constructor(
    private modalService: NgbModal,
    public modal: NgbActiveModal,
    private global: GlobalsService,
    private router: Router,
    private _paymentDevice: PaymentDeviceService,
  ) {
    this.suscribeMember = this.source.subscribe( ()=>{
      this.timer--;
      if (this.timer === 0){
        this.onCancel();
      }
    });
  }
  ngOnDestroy(): void {
    this.suscribeMember.unsubscribe();
  }

  ngOnInit(): void {
  }
  /**
    Abre un modal con el contenido proporcionado.
    @param content Contenido que se mostrará dentro del modal.
    @return void - No retorna ningún valor, pero actualiza `closeResult` con el resultado del cierre.
  **/
  open(content: any): void {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  /**
    Obtiene la razón por la cual se cerró el modal.
    @param reason Razón del cierre del modal.
    @return string - Retorna una cadena que describe la razón del cierre.
  **/
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
 /**
    Maneja la acción de cancelar.
    - Redirige al usuario a la página de inicio.
    - Limpia todos los datos globales.
    - Cierra todos los modales abiertos.
    @return void - No retorna ningún valor.
  **/
  onCancel(){
    this.router.navigate(['/']);
    this.global.clearAll();
    this.modalService.dismissAll();
   if (this._paymentDevice.isOK()) {
     this._paymentDevice.disable();
     this._paymentDevice.clearTransactionData()
     this._paymentDevice.cancelTransaction()
   }
  }
  onConfirm(){
    this.modal.dismiss();
  }
    /**
    Decrementa el tiempo del temporizador.
    @param initial Valor inicial del temporizador.
    @return void - No retorna ningún valor.
  **/
  decrementTime(initial: any) {
    const wait = timer(15000,1000)
    const abc = wait.subscribe(val => {
      this.timer = initial; - val;
    });
  }


}
